module.exports = __webpack_public_path__ + "img/logoNew.c5dd5c19.svg";